import React, { useState, useEffect } from 'react';
import './App.css';
import { db } from './firebaseConfig'; // Certifique-se de que o caminho está correto
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { omitUndefinedDeep } from './firestoreSanitize';

function Perguntas() {
  const navigate = useNavigate();

  const loadQuestions = () => {
    const savedQuestions = JSON.parse(localStorage.getItem('questions'));
    return (
      savedQuestions || {
        nome: '',
        gravarAudio: true,
        questions: [
          { id: 1, tituloBloco: '', question: '', type: 'text', options: [''], required: false },
        ],
      }
    );
  };

  const [questionario, setQuestionario] = useState(loadQuestions());

  useEffect(() => {
    // Salvar as perguntas no localStorage sempre que houver uma mudança
    localStorage.setItem('questions', JSON.stringify(questionario));
  }, [questionario]);

  const handleNameChange = (value) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      nome: value,
    }));
  };

  const handleQuestionChange = (id, value) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: prevQuestionario.questions.map((q) =>
        q.id === id ? { ...q, question: value } : q
      ),
    }));
  };

  const handleQuestionFieldChange = (id, field, value) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: prevQuestionario.questions.map((q) =>
        q.id === id ? { ...q, [field]: value } : q
      ),
    }));
  };

  const handleTypeChange = (id, value) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: prevQuestionario.questions.map((q) => {
        if (q.id !== id) return q;
        if (value === 'text') {
          const { matrixRows: _m, ...rest } = q;
          return { ...rest, type: 'text', options: [] };
        }
        if (value === 'radio') {
          const { matrixRows: _m, ...rest } = q;
          return { ...rest, type: 'radio', options: [{ text: '', skipTo: null }] };
        }
        if (value === 'checkbox') {
          const { matrixRows: _m, ...rest } = q;
          return { ...rest, type: 'checkbox', options: [{ text: '', skipTo: null }] };
        }
        if (value === 'matrix') {
          return {
            ...q,
            type: 'matrix',
            matrixRows: ['', ''],
            options: [
              { text: '', skipTo: null },
              { text: '', skipTo: null },
            ],
          };
        }
        return q;
      }),
    }));
  };

  const handleMatrixRowChange = (qId, rowIndex, value) => {
    setQuestionario((prev) => ({
      ...prev,
      questions: prev.questions.map((q) => {
        if (q.id !== qId) return q;
        const rows = [...(q.matrixRows || [])];
        rows[rowIndex] = value;
        return { ...q, matrixRows: rows };
      }),
    }));
  };

  const addMatrixRow = (qId) => {
    setQuestionario((prev) => ({
      ...prev,
      questions: prev.questions.map((q) =>
        q.id === qId ? { ...q, matrixRows: [...(q.matrixRows || []), ''] } : q
      ),
    }));
  };

  const removeMatrixRow = (qId, rowIndex) => {
    setQuestionario((prev) => ({
      ...prev,
      questions: prev.questions.map((q) => {
        if (q.id !== qId) return q;
        const rows = (q.matrixRows || []).filter((_, i) => i !== rowIndex);
        return { ...q, matrixRows: rows.length ? rows : [''] };
      }),
    }));
  };

  const handleOptionChange = (qId, index, field, value) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: prevQuestionario.questions.map((q) => {
        if (q.id !== qId) return q;
        
        return {
          ...q,
          options: q.options.map((opt, idx) => {
            if (idx !== index) return opt;
            
            // Se a opção é string (formato antigo), converte para objeto
            if (typeof opt === 'string') {
              return field === 'text' 
                ? { text: value, skipTo: null }
                : { text: opt, skipTo: value };
            }
            
            // Se já é objeto, atualiza o campo
            return { ...opt, [field]: value };
          }),
        };
      }),
    }));
  };

  const handleRequiredChange = (id, value) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: prevQuestionario.questions.map((q) =>
        q.id === id ? { ...q, required: value } : q
      ),
    }));
  };

  const addQuestion = () => {
    const newId = questionario.questions && questionario.questions.length
      ? questionario.questions[questionario.questions.length - 1].id + 1
      : 1;
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: [
        ...(prevQuestionario.questions || []),
        { id: newId, tituloBloco: '', question: '', type: 'text', options: [{ text: '', skipTo: null }], required: false },
      ],
    }));
  };

  const addQuestionAfter = (qId) => {
    const qIndex = questionario.questions.findIndex(q => q.id === qId);
    const newId = questionario.questions[questionario.questions.length - 1].id + 1;
    setQuestionario((prev) => {
      const newQuestions = [...prev.questions];
      newQuestions.splice(qIndex + 1, 0, { id: newId, tituloBloco: '', question: '', type: 'text', options: [{ text: '', skipTo: null }], required: false });
      return {
        ...prev,
        questions: newQuestions
      };
    });
  };

  const moveQuestionUp = (qId) => {
    const qIndex = questionario.questions.findIndex(q => q.id === qId);
    if (qIndex === 0) return;
    setQuestionario((prev) => {
      const newQuestions = [...prev.questions];
      [newQuestions[qIndex - 1], newQuestions[qIndex]] = [newQuestions[qIndex], newQuestions[qIndex - 1]];
      return {
        ...prev,
        questions: newQuestions
      };
    });
  };

  const moveQuestionDown = (qId) => {
    const qIndex = questionario.questions.findIndex(q => q.id === qId);
    if (qIndex === questionario.questions.length - 1) return;
    setQuestionario((prev) => {
      const newQuestions = [...prev.questions];
      [newQuestions[qIndex], newQuestions[qIndex + 1]] = [newQuestions[qIndex + 1], newQuestions[qIndex]];
      return {
        ...prev,
        questions: newQuestions
      };
    });
  };

  const removeQuestion = (id) => {
    if (window.confirm('⚠️ Tem certeza que deseja remover esta pergunta?')) {
      setQuestionario((prevQuestionario) => ({
        ...prevQuestionario,
        questions: prevQuestionario.questions.filter((q) => q.id !== id),
      }));
    }
  };

  const addOption = (qId) => {
    setQuestionario((prevQuestionario) => ({
      ...prevQuestionario,
      questions: prevQuestionario.questions.map((q) =>
        q.id === qId ? { ...q, options: [...(q.options || []), { text: '', skipTo: null }] } : q
      ),
    }));
  };

  const removeOption = (qId, index) => {
    if (window.confirm('🗑️ Deseja remover esta opção?')) {
      setQuestionario((prevQuestionario) => ({
        ...prevQuestionario,
        questions: prevQuestionario.questions.map((q) =>
          q.id === qId
            ? { ...q, options: (q.options || []).filter((_, idx) => idx !== index) }
            : q
        ),
      }));
    }
  };

  const duplicateQuestion = (id) => {
    const questionToDuplicate = questionario.questions.find(q => q.id === id);
    if (questionToDuplicate) {
      const newId = questionario.questions[questionario.questions.length - 1].id + 1;
      const duplicatedQuestion = { ...questionToDuplicate, id: newId };
      setQuestionario((prevQuestionario) => ({
        ...prevQuestionario,
        questions: [...prevQuestionario.questions, duplicatedQuestion],
      }));
      alert('✅ Pergunta duplicada com sucesso!');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (window.confirm('📋 Deseja criar este questionário?')) {
      console.log('Enviado: ', questionario);

      // Salvar no Firestore
      try {
        const docRef = await addDoc(
          collection(db, 'questionarios'),
          omitUndefinedDeep({ ...questionario, gravarAudio: true })
        );
        console.log('Documento escrito com ID: ', docRef.id);
        
        // Limpar localStorage após sucesso
        localStorage.removeItem('questions');
        
        alert('✅ Questionário criado com sucesso!');
        
        // Vai pra rota inicial
        navigate('/');
      } catch (e) {
        console.error('Erro ao adicionar documento: ', e);
        alert('❌ Erro ao criar questionário. Tente novamente.');
      }
    }
  };

  return (
    <div className="container">
      <h1>📝 Criar Novo Questionário</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <label>
            📋 Nome do Questionário:
            <input
              type="text"
              value={questionario.nome}
              onChange={(e) => handleNameChange(e.target.value)}
              required
              placeholder="Digite o nome do questionário"
            />
          </label>
        </div>

        <div className="questions-container">
          {questionario.questions && questionario.questions.map((q) => (
            <div key={q.id} className="question-card">
              <div className="question-header">
                <h3>Pergunta {q.id}</h3>
                <span className="required-badge">
                  {q.required ? '⭐ Obrigatória' : '📌 Opcional'}
                </span>
              </div>

              <div className="form-group">
                <label>Título do bloco (opcional):</label>
                <input
                  type="text"
                  value={q.tituloBloco ?? ''}
                  onChange={(e) => handleQuestionFieldChange(q.id, 'tituloBloco', e.target.value)}
                  placeholder="Ex.: Dados pessoais — deixe vazio para continuar no mesmo bloco"
                />
              </div>

              <div className="form-group">
                <label>Pergunta:</label>
                <input
                  type="text"
                  value={q.question}
                  onChange={(e) => handleQuestionChange(q.id, e.target.value)}
                  required={q.required}
                  placeholder="Digite sua pergunta aqui"
                />
              </div>

              <div className="form-group">
                <label>Tipo de Resposta:</label>
                <select
                  value={q.type}
                  onChange={(e) => handleTypeChange(q.id, e.target.value)}
                >
                  <option value="text">📝 Texto</option>
                  <option value="radio">⚪ Escolha única (uma opção)</option>
                  <option value="checkbox">☑ Várias opções (caixas de seleção)</option>
                  <option value="matrix">▦ Matriz (linhas e colunas)</option>
                </select>
              </div>

              {q.type === 'text' ? (
                <div className="form-group">
                  <input 
                    type="text" 
                    placeholder="Resposta em texto livre" 
                    disabled
                    className="preview-input"
                  />
                </div>
              ) : q.type === 'matrix' ? (
                <>
                  <div className="options-section matrix-rows-section">
                    <label>Linhas (uma célula de texto por linha):</label>
                    {(q.matrixRows && q.matrixRows.length ? q.matrixRows : ['']).map((rowLabel, rowIndex) => (
                      <div key={rowIndex} className="option-input-row matrix-row-editor">
                        <span className="option-number">{rowIndex + 1}</span>
                        <input
                          type="text"
                          value={rowLabel}
                          onChange={(e) => handleMatrixRowChange(q.id, rowIndex, e.target.value)}
                          placeholder={`Linha ${rowIndex + 1}`}
                          className="option-text-input"
                        />
                        <button
                          type="button"
                          className="btn-remove-option"
                          onClick={() => removeMatrixRow(q.id, rowIndex)}
                          disabled={(q.matrixRows || ['']).length <= 1}
                          title="Remover linha"
                        >
                          🗑️
                        </button>
                      </div>
                    ))}
                    <button type="button" className="btn-add-option" onClick={() => addMatrixRow(q.id)}>
                      ➕ Adicionar linha
                    </button>
                  </div>
                  <div className="options-section">
                    <label>Colunas (cabeçalhos — uma opção por coluna):</label>
                    {(q.options || []).map((option, index) => {
                      const optionText = typeof option === 'string' ? option : option.text || '';
                      return (
                        <div key={index} className="option-row-container">
                          <div className="option-input-row">
                            <span className="option-number">{index + 1}</span>
                            <input
                              type="text"
                              value={optionText}
                              onChange={(e) => handleOptionChange(q.id, index, 'text', e.target.value)}
                              placeholder={`Coluna ${index + 1}`}
                              className="option-text-input"
                            />
                            <button
                              type="button"
                              className="btn-remove-option"
                              onClick={() => removeOption(q.id, index)}
                              disabled={(q.options || []).length <= 1}
                              title="Remover coluna"
                            >
                              🗑️
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    <button type="button" className="btn-add-option" onClick={() => addOption(q.id)}>
                      ➕ Adicionar coluna
                    </button>
                  </div>
                </>
              ) : (
                <div className="options-section">
                  <label>Opções de Resposta:</label>
                  {q.options.map((option, index) => {
                    // Garante compatibilidade com formato antigo (string) e novo (objeto)
                    const optionText = typeof option === 'string' ? option : option.text || '';
                    const skipTo = typeof option === 'string' ? null : option.skipTo;
                    const qIndex = questionario.questions.findIndex(quest => quest.id === q.id);
                    
                    return (
                      <div key={index} className="option-row-container">
                        <div className="option-input-row">
                          <span className="option-number">{index + 1}</span>
                          <input
                            type="text"
                            value={optionText}
                            onChange={(e) => handleOptionChange(q.id, index, 'text', e.target.value)}
                            placeholder={`Opção ${index + 1}`}
                            className="option-text-input"
                          />
                          <button 
                            type="button" 
                            className="btn-remove-option" 
                            onClick={() => removeOption(q.id, index)}
                            title="Remover opção"
                          >
                            🗑️
                          </button>
                        </div>
                        {q.type === 'radio' && (
                        <div className="skip-logic-row">
                          <label className="skip-label">
                            🔀 Se escolher esta opção, pular para:
                          </label>
                          <select
                            value={skipTo === 'end' ? 'end' : skipTo != null && skipTo !== '' ? String(skipTo) : ''}
                            onChange={(e) =>
                              handleOptionChange(
                                q.id,
                                index,
                                'skipTo',
                                e.target.value === '' ? null : e.target.value === 'end' ? 'end' : parseInt(e.target.value, 10)
                              )
                            }
                            className="skip-select"
                          >
                            <option value="">➡️ Próxima pergunta (padrão)</option>
                            {questionario.questions.map((_, idx) => {
                              if (idx > qIndex) {
                                return (
                                  <option key={idx} value={idx}>
                                    ⏩ Pergunta {idx + 1}
                                  </option>
                                );
                              }
                              return null;
                            })}
                            <option value="end">✅ Finalizar questionário</option>
                          </select>
                        </div>
                        )}
                      </div>
                    );
                  })}
                  <button 
                    type="button" 
                    className="btn-add-option" 
                    onClick={() => addOption(q.id)}
                  >
                    ➕ Adicionar Opção
                  </button>
                </div>
              )}

              <div className="form-group checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={q.required}
                    onChange={(e) => handleRequiredChange(q.id, e.target.checked)}
                  />
                  <span>Marcar como pergunta obrigatória</span>
                </label>
              </div>

              <div className="question-actions">
                <div className="question-actions-row">
                  <button 
                    type="button" 
                    className="btn-move-up" 
                    onClick={() => moveQuestionUp(q.id)}
                    disabled={questionario.questions.findIndex(qu => qu.id === q.id) === 0}
                    title="Mover para cima"
                  >
                    ⬆️
                  </button>
                  <button 
                    type="button" 
                    className="btn-move-down" 
                    onClick={() => moveQuestionDown(q.id)}
                    disabled={questionario.questions.findIndex(qu => qu.id === q.id) === questionario.questions.length - 1}
                    title="Mover para baixo"
                  >
                    ⬇️
                  </button>
                  <button 
                    type="button" 
                    className="btn-add-after" 
                    onClick={() => addQuestionAfter(q.id)}
                    title="Adicionar pergunta abaixo"
                  >
                    ➕ Adicionar Abaixo
                  </button>
                </div>
                <div className="question-actions-row">
                  <button 
                    type="button" 
                    className="btn-duplicate-question" 
                    onClick={() => duplicateQuestion(q.id)}
                  >
                    📋 Duplicar
                  </button>
                  <button 
                    type="button" 
                    className="btn-remove-question" 
                    onClick={() => removeQuestion(q.id)}
                  >
                    🗑️ Remover
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-add-question" 
            onClick={addQuestion}
          >
            ➕ Adicionar Nova Pergunta
          </button>
          <button type="submit" className="btn-create">
            ✨ Criar Questionário
          </button>
        </div>
      </form>
    </div>
  );
}

export default Perguntas;